import getSymbolFromCurrency from "currency-symbol-map";

export const CurrencySymbol = (currency) => {
  return currency !== "GBp"
    ? currency === "ILA"
      ? "₪"
      : getSymbolFromCurrency(currency)
    : "GBX";
};
